import { Component, Inject, Input, EventEmitter, Output, ViewChild } from '@angular/core';

import { Subject, combineLatest } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

import { MultiFilterableSelectComponent } from '../../../../shared/filterable-select/components/multi-filterable-select.component';

import { AntenneService } from '../services/antenne.service';
import { AntenneTLR } from '../entities/antenne-tlr.entity';

@Component({
	selector: 'antenne-filterable-selector',
	templateUrl: 'antenne-filterable-selector.html',
})
export class AntenneFilterableSelectorComponent {
	antennes: AntenneTLR[] = [];
	selectedAntenne: AntenneTLR | undefined = undefined;

	getAntenneLabel = (antenne: AntenneTLR) => antenne.nom;
	
	agenceIdSubject = new Subject<number | null | undefined>();
	selectedAntenneIdSubject = new Subject<number | null>();

	constructor( //
		@Inject(AntenneService) antenneService: AntenneService //
	) {
		// A la reception d'un nouveau numero d'agence, recuperer les antennes rattachees
		let antennes$ = this.agenceIdSubject.pipe(
			mergeMap(
				(agenceId) =>  {
					return agenceId ?
						antenneService.getAntenneTLRByAgence(agenceId)
						:
						antenneService.getAntenneTLRList();
				}
			)
		);
		
		// Une fois les antennes chargees les transmettre au sous-composant
		antennes$.subscribe(
			(antennes : AntenneTLR[]) => this.antennes = antennes
		);

		// Definit comment combiner les donnees sur l'ensemble des antennes connues avec un id d'antenne pour fixer l'antenne actuellement selectionnee 
		combineLatest([antennes$, this.selectedAntenneIdSubject]).subscribe(
			data => {
				let antennes = data[0];
				let antenneId = data[1];
				
				let newSelectedAntenne: AntenneTLR | undefined = undefined; 
				if (antenneId) {
					let antenne = antennes.find(antenne => antenne.id === antenneId);
					newSelectedAntenne = antenne;
				}
				
				if (newSelectedAntenne != this.selectedAntenne) {
					this.selectedAntenne = newSelectedAntenne;
					this.onSelectedAntenneChange(this.selectedAntenne);
				}
			}
		);
	}

	@ViewChild(MultiFilterableSelectComponent) input!: MultiFilterableSelectComponent;

	@Input() id!: string;
	@Input() disabled = false;
	
	// Classes pour l'affichege
	public _labelClass: string = 'col-md-1';
	@Input() set labelClass(value: string | undefined) {
		if (value) {
			this._labelClass = value;
		}	
	}
	get labelClass(): string | undefined {
		return this._labelClass;
	}
	
	public _fieldClass: string = 'col-md-7';
	@Input() set fieldClass(value: string | undefined) {
		if (value) {
			this._fieldClass = value;
		}
	}
	get fieldClass(): string | undefined {
		return this._fieldClass;
	}
	
	@Input() set agenceId(id: number | null | undefined) {
		this.agenceIdSubject.next(id);
	}
	
	private _selectedAntenneId: number | null | undefined = null;
	@Input() set selectedAntenneId(id: number | null | undefined) {
		this._selectedAntenneId = id;
		this.selectedAntenneIdSubject.next(id);
	}
	get selectedAntenneId(): number | null | undefined {
		return this._selectedAntenneId;
	}
	
	@Output() selectedAntenneIdChange = new EventEmitter<number | null>();
	
	@Output() selectedAntenneChange = new EventEmitter<AntenneTLR | null>();
	
	onSelectedAntenneChange(antenne: AntenneTLR | null | undefined) {
		let id = antenne ? antenne.id : null;
		this._selectedAntenneId = id;
		this.selectedAntenneIdChange.emit(id);
		this.selectedAntenneChange.emit(antenne);
	}
}